import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { select, Store } from '@ngrx/store';
import { getAllRelationshipsSelector } from '../../../root-store/relationship-store/relationship.selector';
import { AddConnectionComponent } from '../add-connection-component/add-connection.component';
import { ConnectionsSearchComponent } from '../connections-search-component/connections-search.component';
import { UserConnectionService, UserService } from '../../../shared/services';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConnectRelationshipDialogComponent } from '../connect-relationship-dialog/connect-relationship-dialog.component';
import { SharedConfirmationDialogComponent } from '../shared-confirmation-dialog/shared-confirmation-dialog.component';
import { Subscription } from 'rxjs';
import { relationshipStoreActions } from '@app/root-store';
import { InviteService } from '@app/shared/services/invite/invite.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import * as selectors from '../../../root-store/relationship-store/relationship.selector';
import * as loginSelectors from '../../../root-store/login-store/login.selector';
import { UserTypeEnum } from '@app/enum/UserTypeEnum';
import { EVENTS } from '@app/constants/events.constants';
import { NetworkSetupTitleEnum } from '../network-setup/network-setup-enums';
import { capitalizeFirstCharacterInWord } from '@app/shared/utils';
import { FunctionsService } from '@app/shared/services/utils/functions/functions.service';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'app-connected-user-card',
  templateUrl: './connected-user-card.component.html',
})
export class ConnectedUserCardComponent implements OnInit, OnDestroy {
  @Input() user: any; // Replace 'any' with an interface or type representing your user data model
  @Input() relationshipType;
  @Output() editEmitter: EventEmitter<any> = new EventEmitter();
  @Output() handleConnectCheckEmitter: EventEmitter<any> = new EventEmitter();
  @Output() handleConnectionsExistingEmitter: EventEmitter<any> = new EventEmitter();
  @Output() relationShipCountEmitter: EventEmitter<any> = new EventEmitter();
  @Output() relationshipListEmitter: EventEmitter<any> = new EventEmitter();
  @Output() allRelationshipListEmitter: EventEmitter<any> = new EventEmitter();
  allRelationshipList = [];
  @Input() isFromNetworkRequest = false;
  @Input() showCheckBox = true;
  @Input() networkRequestFilteredList = [];
  guardianLIst;

  isProfessional = false;
  constructor(
    private dialog: MatDialog,
    private store: Store,
    private graphqlService: UserConnectionService,
    private _modalService: NgbModal,
    private _userConnectionService: UserConnectionService,
    private _inviteService: InviteService,
    private _toastr: ToastrService,
    private _ch: ChangeDetectorRef,
    private store$: Store,
    private router: Router,
    private _userService: UserService,
    private _utilFunctionService: FunctionsService
  ) {
    this.subscription.add(
      this.store.pipe(select(loginSelectors.getCurrentUserFullDetails)).subscribe((data) => {
        if (data && data.id) {
          this.currentUser = data;
          if (this.currentUser?.user_type == UserTypeEnum.Professional) {
            this.isProfessional = true;
          } else {
            this.isProfessional = false;
          }

          // get relationship requests
          this.getRelationshipRequests();
          // // get accepted requests
          // this.getAcceptedRequests('home');
          // // get declined requests
          // this.getDeclinedRequests('home');
        } else {
          this.currentUser = null;
        }
      })
    );
  }
  spouseList = [];
  filteredList = [];
  filterList = [];

  currentUser = undefined;
  subscription = new Subscription();

  ngOnInit(): void {
    this.handleType(this.relationshipType.toLowerCase());
    this.currentUser = this.user;
    this.getRelationshipRequests();

    if (this.relationshipType.toLowerCase() !== 'family users' || this.relationshipType.toLowerCase() !== 'professional connections') {
      this.subscription.add(
        this.store.select(getAllRelationshipsSelector()).subscribe((res) => {
          this.allRelationshipList = res;
          this.allRelationshipListEmitter.emit(res);
          this.getRelationshipList(this.relationshipType.toLowerCase());
        })
      );
    } else {
      this.subscription.add(
        this.store.pipe(select(selectors.getAllRelationShipSortSelector(this.user?.id, 'Last Added', ''))).subscribe((data) => {
          this.allRelationshipList = data;
          this.allRelationshipListEmitter.emit(data);
          this.getRelationshipList(this.relationshipType.toLowerCase());
        })
      );
    }

    this.subscription.add(
      this._userService.getGuardianUsers().subscribe(
        (res) => {
          this.guardianLIst = res;
          this._ch.detectChanges();
        },
        (error) => {}
      )
    );
  }

  viewData: Array<any> = [];
  editAdminDialogFunction(params) {
    this.viewData['user'] = params;
    // this.activeModal.close(NetworkEditConnectionComponent);
    const modalRef = this._modalService.open(ConnectRelationshipDialogComponent, {
      windowClass: ' ',
      modalDialogClass: ' ',
    });
    modalRef.componentInstance.data = this.viewData;
    modalRef.componentInstance.filterList = this.filterList;
    modalRef.componentInstance.isFromNetworkRequest = this.isFromNetworkRequest;
    modalRef.result
      .then((response) => {
        if (response) this.trackEventsInMixPanel('edit');
        // this.onEditComplete.emit();
      })
      .catch((error: any) => {
        // this.toastr.error(error.error.message);
      });
  }
  editGuardian(params) {
    this.subscription.add(
      this._userService.getGuardianUserDetails(params.user_id).subscribe((res) => {
        const filteredUser = { ...params, ...res };
        const modalRef3 = this.dialog.open(AddConnectionComponent, {
          autoFocus: false,
          disableClose: true,
          panelClass: 'full-window-dialog-2',
          data: {
            filterList: [],
            formNetworkSetup: true,
            userDetails: filteredUser, // Now correctly passing filtered user
          },
        });
        this.subscription.add(modalRef3.afterClosed().subscribe(() => {}));
      })
    );
  }

  addNewUser() {
    const modalRef3 = this.dialog.open(AddConnectionComponent, {
      autoFocus: false,
      disableClose: true,
      panelClass: 'full-window-dialog-2',
      data: {
        type: this.relationshipType,
        filterList: this.filterList,
        formNetworkSetup: true,
      },
    });
    this.subscription.add(
      modalRef3.afterClosed().subscribe(
        (res) => {
          this.ngOnInit();
        },
        (error) => {}
      )
    );
  }
  searchExistingUsers() {
    const dialogRef = this.dialog.open(ConnectionsSearchComponent, {
      panelClass: 'full-window-dialog-2',
      data: {
        type: this.relationshipType,
        filterList: this.filterList,
        existingItems: this.filteredList,
        title: 'Global User Search',
      },
    });
    this.subscription.add(
      dialogRef.afterClosed().subscribe((res) => {
        this.subscription.add(this.graphqlService.getConnections().subscribe((data) => {}));
      })
    );
  }

  getRelationshipList(type: NetworkSetupTitleEnum | string) {
    if (this.isFromNetworkRequest) {
      if (type.includes(NetworkSetupTitleEnum.FamilyUsers) || type.includes('family users') || type.includes('family connections')) {
        const familyUsers = new Set([
          'husband',
          'wife',
          'spouse',
          'fiancee',
          'civil partner',
          'domestic partner',
          'son',
          'daughter',
          'step-son',
          'step-daughter',
          'child',
          'mother',
          'father',
          'step-mother',
          'step-father',
          'parent',
          'brother',
          'sister',
          'step-brother',
          'step-sister',
          'sibling',
          'grandmother',
          'grandfather',
          'step-grandmother',
          'step-grandfather',
          'great-grandparent',
          'great-great-grandparent',
          'great-grandfather',
          'great-grandmother',
          'great-great-grandfather',
          'great-great-grandmother',
          'grandparent',
          'grandson',
          'granddaughter',
          'step-grandson',
          'step-granddaughter',
          'great-grandchild',
          'great-great-grandchild',
          'great-grandson',
          'great-granddaughter',
          'great-great-grandson',
          'great-great-granddaughter',
          'grandchild',
          'legal dependent',
          'mother in-law',
          'father in-law',
          'sister in-law',
          'brother in-law',
          'son in-law',
          'daughter in-law',
          'in-law',
          'aunt',
          'great-aunt',
          'great-great-aunt',
          'paternal aunt',
          'maternal aunt',
          'great-paternal aunt',
          'great-maternal aunt',
          'great-great-paternal aunt',
          'great-great-maternal aunt',
          'uncle',
          'great-uncle',
          'great-great-uncle',
          'maternal uncle',
          'paternal uncle',
          'great-paternal uncle',
          'great-maternal uncle',
          'great-great-paternal uncle',
          'great-great-maternal uncle',
          'niece',
          'great-niece',
          'great-great-niece',
          'nephew',
          'great-nephew',
          'great-great-nephew',
          'cousin',
          'other family member',
          'significant other',
          'co-habitant',
        ]);
        this.filteredList = this.allRelationshipList?.filter((user) => user?.user_type?.toLowerCase() !== 'professional');
      } else if (
        type.includes(NetworkSetupTitleEnum.ProfessionalUsers) ||
        type.includes('professional users') ||
        type.includes('professional connections')
      ) {
        const professionalUsers = new Set([
          'professional - general',
          'professional - legal',
          'professional - financial',
          'professional - insurance',
          'professional - medical',
          'professional - assistant',
          'professional - other',
          'meta advisor',
          'advisor',
          'professional - staff',
        ]);

        // this.filteredList = this.allRelationshipList.filter((user) => professionalUsers.has(user.relationship_name.toLowerCase()));
        this.filteredList = this.allRelationshipList?.filter((user) => user?.user_type?.toLowerCase() === 'professional');
      } else if (type.includes('clients')) {
        this.filteredList = this.allRelationshipList.filter((user) => user.relationship_name.toLowerCase().includes('client'));
      }
    } else {
      if (type.includes('immediate family members')) {
        this.filteredList = this.allRelationshipList.filter(
          (user) =>
            user.relationship_name.toLowerCase() == 'husband' ||
            user.relationship_name.toLowerCase() == 'wife' ||
            user.relationship_name.toLowerCase() == 'Spouse' ||
            user.relationship_name.toLowerCase() == 'Fiancee' ||
            user.relationship_name.toLowerCase() == 'civil partner' ||
            user.relationship_name.toLowerCase() == 'domestic partner' ||
            user.relationship_name.toLowerCase() == 'son' ||
            user.relationship_name.toLowerCase() == 'daughter' ||
            user.relationship_name.toLowerCase() == 'step-daughter' ||
            user.relationship_name.toLowerCase() == 'step-son' ||
            user.relationship_name.toLowerCase() == 'father' ||
            user.relationship_name.toLowerCase() == 'mother' ||
            user.relationship_name.toLowerCase() == 'step-mother' ||
            user.relationship_name.toLowerCase() == 'step-father' ||
            user.relationship_name.toLowerCase() == 'stepmother' ||
            user.relationship_name.toLowerCase() == 'stepfather' ||
            user.relationship_name.toLowerCase() == 'brother' ||
            user.relationship_name.toLowerCase() == 'sister' ||
            user.relationship_name.toLowerCase() == 'step-brother' ||
            user.relationship_name.toLowerCase() == 'step-sister' ||
            user.relationship_name.toLowerCase() == 'granddaughter' ||
            user.relationship_name.toLowerCase() == 'grandson' ||
            user.relationship_name.toLowerCase() == 'spouse' ||
            user.relationship_name.toLowerCase() == 'step-granddaughter' ||
            user.relationship_name.toLowerCase().includes('mother') ||
            user.relationship_name.toLowerCase().includes('father') ||
            user.relationship_name.toLowerCase().includes('son') ||
            user.relationship_name.toLowerCase().includes('daughter') ||
            user.relationship_name.toLowerCase() == 'legal dependent' ||
            user.relationship_name.toLowerCase() == 'step-son' ||
            user.relationship_name.toLowerCase() == 'grandmother' ||
            user.relationship_name.toLowerCase() == 'grandfather' ||
            user.relationship_name.toLowerCase() == 'grand-father' ||
            user.relationship_name.toLowerCase() == 'grand-mother' ||
            user.relationship_name.toLowerCase() == 'step-grandmother' ||
            user.relationship_name.toLowerCase() == 'step-grandfather' ||
            user.relationship_name.toLowerCase() == 'sibling' ||
            user.relationship_name.toLowerCase().includes('child') ||
            user.relationship_name.toLowerCase() == 'step-grandson'
        );
      } else if (type.includes('in-laws')) {
        this.filteredList = this.allRelationshipList.filter((user) => user.relationship_name.toLowerCase().includes('law'));
      } else if (type.includes('extended family members') || type.includes('extended family')) {
        this.filteredList = this.allRelationshipList.filter(
          (user) =>
            user.relationship_name.toLowerCase().includes('aunt') ||
            user.relationship_name.toLowerCase().includes('uncle') ||
            user.relationship_name.toLowerCase().includes('niece') ||
            user.relationship_name.toLowerCase().includes('nephew') ||
            user.relationship_name.toLowerCase().includes('cousin') ||
            user.relationship_name.toLowerCase().includes('other family member')
        );
      } else if (type.includes('other relationships')) {
        this.filteredList = this.allRelationshipList.filter(
          (user) =>
            user.relationship_name.toLowerCase().includes('friend') ||
            user.relationship_name.toLowerCase().includes('roommate') ||
            user.relationship_name.toLowerCase().includes('co-worker') ||
            user.relationship_name.toLowerCase().includes('co-habitant') ||
            user.relationship_name.toLowerCase().includes('significant other') ||
            user.relationship_name.toLowerCase().includes('co-habitant') ||
            user.relationship_name.toLowerCase().includes('business partner') ||
            user.relationship_name.toLowerCase().includes('mentor')
        );
      } else if (type.includes('service providers')) {
        this.filteredList = this.allRelationshipList.filter(
          (user) => user.relationship_name.toLowerCase().includes('professional') || user.relationship_name.toLowerCase().includes('advisor')
        );
      } else if (type.includes('staff')) {
        this.filteredList = this.allRelationshipList.filter((user) => user.relationship_name.toLowerCase().includes('staff'));
      } else if (type.includes('client')) {
        this.filteredList = this.allRelationshipList.filter((user) => user.relationship_name.toLowerCase().includes('client'));
      }
    }
    this.filteredList = this.filteredList.map((filteredListItem) => {
      const exist = this.relationshipRequests.find(
        (item) => filteredListItem.from_user_id === item.from_user_id && filteredListItem.to_user_id === item.to_user_id
      );
      if (exist) {
        return {
          ...filteredListItem,
          relationshipRequests: true,
        };
      }
      return filteredListItem;
    });

    // else if (type === 'friends') {
    //   this.filteredList = this.allRelationshipList.filter((user) => user.relationship_name.toLowerCase() == 'friend');
    // } else if (type === 'other dependents') {
    //   this.filteredList = this.allRelationshipList.filter((user) => user.relationship_name.toLowerCase() == 'other');
    // }
    // this.filteredList = this.removeDuplicates2(this.filteredList);

    this.relationShipCountEmitter.emit(this.filteredList.length);
    this.relationshipListEmitter.emit(this.filteredList);
    if (this.filteredList.length > 0) {
      this.handleConnectionsExistingEmitter.emit(true);
    }
  }
  // removeDuplicates(array) {
  //   return array.filter((v, i, a) => a.findIndex((v2) => v2.user_id === v.user_id) === i);
  // }
  // removeDuplicates2(arr) {
  //   const uniqueSet = new Set(arr.map(JSON.stringify));
  //   const uniqueArray = Array.from(uniqueSet).map((value: string, index: number, array: unknown[]) => JSON.parse(value));
  //   return uniqueArray;
  // }
  deleteRequest(relationship: any) {
    let deleteText;

    const data2 = relationship.connection_status === 'pending' && relationship.connection_requested_user_id != this.user.id;

    relationship.connection_status === 'approved'
      ? (deleteText = `I understand ${
          relationship?.user_first_name + ' ' + relationship?.user_last_name
        }'s account and information will be permanently deleted and unrecoverable.`)
      : data2
      ? (deleteText = `Are you sure you want to delete the Relationship request sent to ${relationship.user_first_middle_name}?`)
      : (deleteText = `Are you sure you want to decline ${relationship.user_first_middle_name}'s relationship request?`);

    const sharedDialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
      width: '500px',
      data: {
        title:
          relationship.connection_status === 'approved' ? 'Delete Guardian User' : data2 ? 'Delete Network Request' : 'Decline Relationship Request',
        materialIcon: 'delete',
        text: deleteText,
        proceedTitle: relationship.connection_status === 'approved' ? 'Delete' : data2 ? 'Delete' : 'Decline',
      },
    });

    this.subscription.add(
      sharedDialogRef.afterClosed().subscribe((confirmation) => {
        if (confirmation) {
          let finalData = {
            relationship_name: relationship.relationship_name,
            to_user_id: relationship.to_user_id,
            from_user_id: relationship.from_user_id,
          };

          this.subscription.add(
            this._userConnectionService.deleteUserConnection(finalData).subscribe((data) => {
              this.subscription.add(
                this._inviteService.dropInvite(relationship).subscribe((data: any) => {
                  this._toastr.success('Relationship has been deleted.');
                  this.trackEventsInMixPanel('delete');
                  this.store$.dispatch(new relationshipStoreActions.AllRelationships());
                })
              );
            })
          );
        }
      })
    );
  }
  handleConnectCheck(t) {
    this.handleConnectCheckEmitter.emit(t);
  }
  handleType(type: string) {
    if (type.includes('family users') || type.includes('immediate family members') || type.includes('family connections')) {
      this.filterList = [
        'husband',
        'wife',
        'spouse',
        'fiancee',
        'civil partner',
        'domestic partner',
        'son',
        'daughter',
        'step-son',
        'step-daughter',
        'child',
        'mother',
        'father',
        'step-mother',
        'step-father',
        'parent',
        'brother',
        'sister',
        'step-brother',
        'step-sister',
        'sibling',
        'grandmother',
        'grandfather',
        'step-grandmother',
        'step-grandfather',
        'great-grandparent',
        'great-great-grandparent',
        'great-grandfather',
        'great-grandmother',
        'great-great-grandfather',
        'great-great-grandmother',
        'grandparent',
        'grandson',
        'granddaughter',
        'step-grandson',
        'step-granddaughter',
        'great-grandchild',
        'great-great-grandchild',
        'great-grandson',
        'great-granddaughter',
        'great-great-grandson',
        'great-great-granddaughter',
        'grandchild',
        'legal dependent',
        'mother in-law',
        'father in-law',
        'sister in-law',
        'brother in-law',
        'son in-law',
        'daughter in-law',
        'in-law',
        'aunt',
        'great-aunt',
        'great-great-aunt',
        'paternal aunt',
        'maternal aunt',
        'great-paternal aunt',
        'great-maternal aunt',
        'great-great-paternal aunt',
        'great-great-maternal aunt',
        'uncle',
        'great-uncle',
        'great-great-uncle',
        'maternal uncle',
        'paternal uncle',
        'great-paternal uncle',
        'great-maternal uncle',
        'great-great-paternal uncle',
        'great-great-maternal uncle',
        'niece',
        'great-niece',
        'great-great-niece',
        'nephew',
        'great-nephew',
        'great-great-nephew',
        'cousin',
        'other family member',
        'girlfriend',
        'boyfriend',
        'significant other',
        'co-habitant',
        'friend',
        'co-worker',
        'roommate',
        'mentor',
        'business partner',
      ];
    } else if (type == 'in-laws') {
      this.filterList = ['Mother In-Law', 'Father In-Law', 'Sister In-Law', 'Brother In-Law', 'Son In-Law', 'Daughter In-Law', 'In-Law', 'in-law'];
    } else if (type == 'extended family members' || type == 'extended family') {
      this.filterList = [
        'aunt',
        'great-aunt',
        'great-great-aunt',
        'paternal aunt',
        'maternal aunt',
        'great-paternal aunt',
        'great-maternal aunt',
        'great-great-paternal aunt',
        'great-great-maternal aunt',
        'uncle',
        'great-uncle',
        'great-great-uncle',
        'maternal uncle',
        'paternal uncle',
        'great-paternal uncle',
        'great-maternal uncle',
        'great-great-paternal uncle',
        'great-great-maternal uncle',
        'niece',
        'great-niece',
        'great-great-niece',
        'nephew',
        'great-nephew',
        'great-great-nephew',
        'cousin',
        'other family member',
      ];
    } else if (type == 'other relationships') {
      this.filterList = [
        'girlfriend',
        'boyfriend',
        'girl friend',
        'boy friend',
        'significant other',
        'co-habitant',
        'friend',
        'co-worker',
        'roommate',
        'mentor',
        'business partner',
      ];
    } else if (type == 'service providers' || type == 'professional users' || type == 'professional connections') {
      this.filterList = [
        'professional',
        'professional - general',
        'professional - legal',
        'professional - financial',
        'professional - insurance',
        'professional - medical',
        'professional - assistant',
        'professional - other',
        'professional - staff',
        'meta advisor',
        'advisor',
      ];
    } else if (type == 'staff') {
      this.filterList = ['Professional - Staff', 'Staff'];
    } else if (type == 'client') {
      this.filterList = ['client'];
    } else {
      this.filterList = [];
    }
  }

  relationshipRequests = [];
  getRelationshipRequests() {
    if (this.router.url.includes('/office-network/my-network')) {
      this.subscription.add(
        this.store.pipe(select(selectors.getRequestAllRelationshipWithFilter(this.currentUser?.id, false))).subscribe((response) => {
          this.relationshipRequests = [...response];
        })
      );
    } else if (this.router.url.includes('/office-network/my-prof-relationships')) {
      this.subscription.add(
        this.store.pipe(select(selectors.getRequestAllRelationshipWithFilter(this.currentUser?.id, true))).subscribe((response) => {
          this.relationshipRequests = [...response];
        })
      );
    } else {
      this.subscription.add(
        this.store.pipe(select(selectors.getRequestAllRelationship(this.currentUser?.id, this.isProfessional))).subscribe((response) => {
          this.relationshipRequests = [...response];
        })
      );
    }
  }
  acceptRelationshIpRequest(connetion) {
    let userConnectionData = {
      to_user_id: connetion.to_user_id,
      from_user_id: connetion.from_user_id,
      status: 'approved',
    };

    this.subscription.add(
      this._userConnectionService.userConnectionUpdate(userConnectionData).subscribe(
        (data: any) => {
          let name = connetion.user_first_middle_name + ' ' + connetion.user_last_name;
          let relationship_type = data.relationship_name;
          this._toastr.success(' ' + connetion.user_first_middle_name + ' has been added to your network.');
          this.store.dispatch(new relationshipStoreActions.AllRelationships());

          this.subscription.add(this._userConnectionService.sendRelationshipRequestAcceptNotification(userConnectionData).subscribe());
          // this.cd.detectChanges();
          this.ngOnInit();
        },
        (error: any) => {
          this._toastr.error(error);
        }
      )
    );
  }
  declineRelationshIpRequest(relationship) {
    let deleteText;

    const data2 = relationship.connection_status === 'pending' && relationship.connection_requested_user_id != this.currentUser.id;

    relationship.connection_status === 'approved'
      ? (deleteText = `All permissions and shared information access between you and ${relationship.user_first_middle_name} will be removed.`)
      : data2
      ? (deleteText = `Are you sure you want to Decline the Relationship request sent from ${relationship.user_first_middle_name}?`)
      : (deleteText = `Are you sure you want to decline ${relationship.user_first_middle_name}'s relationship request?`);

    const sharedDialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
      width: '500px',
      data: {
        title:
          relationship.connection_status === 'approved'
            ? 'Decline Relationship'
            : data2
            ? 'Decline Relationship Request'
            : 'Decline Relationship Request',
        materialIcon: 'delete',
        text: deleteText,
        proceedTitle: relationship.connection_status === 'approved' ? 'Delete' : data2 ? 'Decline ' : 'Decline ',
      },
    });

    this.subscription.add(
      sharedDialogRef.afterClosed().subscribe((confirmation) => {
        if (confirmation) {
          let finaldata = {
            relationship_name: relationship.relationship_name,
            to_user_id: relationship.to_user_id,
            from_user_id: relationship.from_user_id,
            relationship_id: relationship.relationship_id,
          };

          this.subscription.add(
            this._userConnectionService.deleteUserConnection(finaldata).subscribe(
              (data: any) => {
                let name = relationship.user_first_middle_name + ' ' + relationship.user_last_name;
                let relationship_type = relationship.connection_relationship_type;
                // this._cd.markForCheck();

                this.store.dispatch(new relationshipStoreActions.AllRelationships());
                // this.store$.dispatch(new loginStoreActions.ConnectionRequestAction());
                if (relationship.connection_status === 'approved') {
                  this._toastr.success('Relationship with ' + name + ' is deleted.');
                } else {
                  this._toastr.success(' ' + name + "'s relationship request is deleted.");
                }
                if (relationship.connection_status === 'approved') {
                  this.subscription.add(this._userConnectionService.sendRelationshipDeleteNotification(finaldata).subscribe());
                } else {
                  this.subscription.add(this._userConnectionService.sendRelationshipRequestDeclineNotification(finaldata).subscribe());
                }
                this.ngOnInit();
                // this._cd.detectChanges();
              },
              (error: any) => {
                this._toastr.error(error.error.message);
              }
            )
          );
        }
      })
    );
  }

  trackEventsInMixPanel(actionType) {
    const events =
      this.relationshipType === 'Immediate Family Users' || this.relationshipType === 'Family Users'
        ? [{ eventName: EVENTS[`network_setup_immediate_family_${actionType}_change`] }]
        : this.relationshipType === 'Professional Users'
        ? [{ eventName: EVENTS[`network_setup_professional_${actionType}_change`] }]
        : this.relationshipType === 'In-Laws'
        ? [{ eventName: EVENTS[`network_setup_in_laws_${actionType}_change`] }]
        : this.relationshipType === 'Extended Family Members'
        ? [{ eventName: EVENTS[`network_setup_extended_family_${actionType}_change`] }]
        : this.relationshipType === 'Other Relationships'
        ? [{ eventName: EVENTS[`network_setup_other_relationship_${actionType}_change`] }]
        : this.relationshipType === 'Service Providers'
        ? [{ eventName: EVENTS[`network_setup_service_providers_${actionType}_change`] }]
        : this.relationshipType === 'Staff'
        ? [{ eventName: EVENTS[`network_setup_staff_${actionType}_change`] }]
        : [];
    this._userService.trackEventsInMixPanel(events).then((response) => {});
  }
  existingMember;
  // method to start impersonating
  startImpersonating(existingMember) {
    this.existingMember = existingMember;
    // actual log in user -> switch_from_user_id
    let switchFromUserId: number = this.user.id;
    // user we need to view (impersonating user) -> switch_to_user_id
    let switchToUserId: number = this.existingMember?.user_id;
    let userName: string = capitalizeFirstCharacterInWord(
      this.existingMember?.nick_name || this.existingMember?.user_first_middle_name + ' ' + this.existingMember?.user_last_name
    );
    this._utilFunctionService.startImpersonating(switchToUserId, switchFromUserId, userName, true);
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this._userService.cleanupWorker();
  }
}
